import Brace from "backbone.brace";
import ReportMetaModel from "./report-meta";

const Model = Brace.Model.extend({
  namedAttributes: {
    data: Array,
    draw: Number,
    error: String,
    meta: ReportMetaModel,
    recordsTotal: Number,
    recordsFiltered: Number,
    singleRecord: Array,
  },
  defaults: {
    singleRecord: [],
  },
});

export { Model as default };
